import React from 'react';

import styled from 'styled-components';

export const TabContent = styled.div.attrs({ className: 'mini-scroll' })`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  min-height: 0;
  padding-right: 4px;
  overflow-y: auto;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
`;

const PanelHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const PanelTitle = styled.h2`
  margin: 0;
  font-family: var(--font-bold);
  font-size: 18px;
`;

const PanelDescription = styled.span`
  color: var(--text-secondary);
  font-size: 13px;
`;

export const StatusBadge = styled.span<{ error?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 12px;
  color: ${({ error }) => (error ? 'var(--error-red-dark)' : 'var(--positive-green-dark)')};
  background: ${({ error }) => (error ? 'var(--error-red-background)' : 'var(--positive-green-light)')};
  font-size: 12px;
  text-transform: capitalize;
`;

export const TaskName = styled.span`
  color: var(--text-primary);
  font-family: var(--font-bold);
  word-break: break-word;
`;

export const SecondaryText = styled.span`
  color: var(--text-secondary);
  font-size: 12px;
  word-break: break-word;
`;

export const WorkerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CenteredState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
`;

type Props = {
  title: string;
  description: React.ReactNode;
  action?: React.ReactNode;
};

export const TaskQueueTabHeader = ({ title, description, action }: Props) => (
  <PanelHeader>
    <PanelHeading>
      <PanelTitle>{title}</PanelTitle>
      <PanelDescription>{description}</PanelDescription>
    </PanelHeading>
    {action}
  </PanelHeader>
);
